<template>
  <div>
    <div
      v-if="displayFullScreen"
      class="fullscreen-container"
    >
      <div class="main-fullscreen-container">
        <div id="top-info">
          <div @click="displayFullScreen = false">
            {{ $t('myday.cancel') }}
          </div>
          <span>{{ $t('form.select') }}</span>
        </div>
        <span id="form-title">{{ label }}</span>

        <div class="date-container bordered-bottom">
          <label>{{ $t('form.start_date') }}</label>
          <select v-model="defaultFilters.startDay">
            <option
              v-for="i in startDaysList"
              :key="`start-day-${i}`"
              :value="i"
            >
              {{ i }}
            </option>
          </select>
          /
          <select v-model="defaultFilters.startMonth">
            <option
              v-for="i in [...Array(12).keys()].map(m => m + 1)"
              :key="`start-month-${i}`"
              :value="i"
            >
              {{ i }}
            </option>
          </select>
        </div>

        <div class="date-container bordered-bottom">
          <label>{{ $t('form.end_date') }}</label>
          <select v-model="defaultFilters.endDay">
            <option
              v-for="i in endDaysList"
              :key="`end-day-${i}`"
              :value="i"
            >
              {{ i }}
            </option>
          </select>
          /
          <select v-model="defaultFilters.endMonth">
            <option
              v-for="i in [...Array(12).keys()].map(m => m + 1)"
              :key="`end-month-${i}`"
              :value="i"
            >
              {{ i }}
            </option>
          </select>
        </div>
      </div>

      <div class="button-fixed">
        <button
          style="user-select: none"
          class="btn-custom"
          type="button"
          @click="validateField()"
        >
          {{ $t('form.validate') }}
        </button>
      </div>
    </div>

    <div
      v-if="!displayFullScreen"
      style="text-align: left"
      class="full-screen bordered-bottom"
    >
      <label
        class="label"
        @click="displayFullScreen = true"
      >{{ label }}</label>
      <div class="main-form">
        <div
          class="segments"
          @click="displayFullScreen = true"
        >
          <div
            v-if="filters"
            class="segment"
          >
            <span>
              {{ filters.startDay.toString().padStart(2, '0') }}/{{ filters.startMonth.toString().padStart(2, '0') }} -
              {{ filters.endDay.toString().padStart(2, '0') }}/{{ filters.endMonth.toString().padStart(2, '0') }}
            </span>
          </div>
        </div>
        <div
          v-if="filters != null"
          class="delete-values"
          @click="[(filters = null), storeData()]"
        >
          <img
            src="@/assets/icons/close.png"
            alt="clear field"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'FullScreenDayMonthInterval',
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    search: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: [Object, Array],
      default: null
    }
  },
  emits: ['addData'],
  data() {
    return {
      displayFullScreen: false,
      defaultFilters: {
        startDay: moment().date(),
        startMonth: moment().month() + 1,
        endDay: moment().date(),
        endMonth: moment().month() + 1
      },
      filters: null,
      moment
    }
  },
  computed: {
    startDaysList() {
      if (this.defaultFilters.startMonth === 2) {
        return [...Array(29).keys()].map(i => i + 1)
      } else if ([1, 3, 5, 7, 8, 10, 12].includes(this.defaultFilters.startMonth)) {
        return [...Array(31).keys()].map(i => i + 1)
      } else {
        return [...Array(30).keys()].map(i => i + 1)
      }
    },
    endDaysList() {
      if (this.defaultFilters.endMonth === 2) {
        return [...Array(29).keys()].map(i => i + 1)
      } else if ([1, 3, 5, 7, 8, 10, 12].includes(this.defaultFilters.endMonth)) {
        return [...Array(31).keys()].map(i => i + 1)
      } else {
        return [...Array(30).keys()].map(i => i + 1)
      }
    }
  },
  watch: {
    defaultFilters: {
      handler() {
        if (this.defaultFilters.startDay > this.startDaysList.at(-1)) {
          this.defaultFilters.startDay = this.startDaysList.at(-1)
        }
        if (this.defaultFilters.endDay > this.endDaysList.at(-1)) {
          this.defaultFilters.endDay = this.endDaysList.at(-1)
        }
      },
      deep: true
    }
  },
  mounted() {
    if (
      this.defaultValue &&
      typeof this.defaultValue === 'object' &&
      this.defaultValue.value1 &&
      this.defaultValue.value2
    ) {
      const defaultValue = [...this.defaultValue.value1.split('/'), ...this.defaultValue.value2.split('/')]
      this.filters = {
        startDay: parseInt(defaultValue[0]),
        startMonth: parseInt(defaultValue[1]),
        endDay: parseInt(defaultValue[2]),
        endMonth: parseInt(defaultValue[3])
      }
      this.defaultFilters = this.filters
      this.storeData()
    }
  },
  methods: {
    formatData(label, value, extra = null) {
      return [
        {
          label,
          value: {
            value1: `${value.startDay.toString().padStart(2, '0')}/${value.startMonth.toString().padStart(2, '0')}`,
            value2: `${value.endDay.toString().padStart(2, '0')}/${value.endMonth.toString().padStart(2, '0')}`
          },
          extra,
          operator: 'BETWEEN'
        }
      ]
    },
    validateField() {
      this.filters = this.defaultFilters
      this.storeData()
      this.displayFullScreen = false
    },
    storeData() {
      this.$emit('addData', {
        value: this.filters ? this.formatData(this.label, this.filters, this.type_list) : null,
        name: this.name
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .fullscreen-container {
    position: fixed;
    inset: 0;
    z-index: 200;
    background-color: #fff;

    .main-fullscreen-container {
      margin: 10px 20px 0;
      display: flex;
      flex-direction: column;

      #top-info {
        margin-top: 30px;
        margin-bottom: 7px;

        > div {
          position: absolute;
          width: 60px;
          z-index: 40;
          left: 20px;
          padding: 6px 6px 5px 0;
        }

        > span {
          width: 100%;
          font-size: 1.2rem !important;
          text-align: center;
          display: block;
          padding: 0 63px;
          line-height: 18px;
        }
      }

      #form-title {
        font-size: 20px;
      }

      .date-container {
        display: flex;
        text-align: left;
        margin: 1rem 0 0;

        label {
          width: 85%;
          padding-left: 12px;
          color: #777;
          font-size: 0.75rem !important;
          font-weight: bold;
        }

        select {
          width: 15%;
          appearance: none;
          text-indent: 4px;
          text-overflow: '';
          padding-right: 4px;
          background-image: url('@/assets/icons/arrow-select.png');
          background-position: center right;
          background-origin: content-box;
          background-repeat: no-repeat;
          background-size: contain;
          color: rgb(var(--secondary-color));
          border: none;
        }
      }
    }

    .button-fixed {
      position: fixed;
      bottom: 0;
      background-color: white;
      width: 100%;
      padding: 1rem;
    }
  }

  .full-screen {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 10px 0;

    .label {
      padding-left: 12px;
      color: #777;
      font-size: 0.75rem !important;
      text-align: left;
    }

    .main-form {
      display: flex;
      padding-left: 12px;

      .segments {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;

        .segment {
          font-size: 0.8rem !important;

          > span {
            margin-right: 5px;
          }
        }
      }
    }

    .delete-values {
      padding: 5px;
      place-self: center center;

      > img {
        height: 1rem;
      }
    }
  }
</style>
